import React, { useEffect, useState } from "react";
import axios from "axios";
import './Profileinfo.css';

const Profileinfo = () => {
  const [profiles, setProfiles] = useState([]);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/personal-info`)
      .then(response => {
        setProfiles(response.data);
      })
      .catch(error => {
        console.error("Error fetching profile data:", error);
      });
  }, []);

  return (
    <React.Fragment>
      <div className="profileinfo-container">
        <h2 className="profileinfo-head">Profile Information</h2>
        <table className="profileinfo-table">
          <thead>
            <tr>
              <th className="profile-label" >Profile ID</th>
              <th className="profile-label-1" >Job ID</th>
              <th>Surname</th>
              <th>Name</th>
              <th>Email</th>
              <th>Phn Number</th>
              {/* <th>PID</th> */}
            </tr>
          </thead>
          <tbody>
            {Array.isArray(profiles) ? (
              profiles.map((profile, index) => (
                <tr key={index}>
                  <td>{profile.profileId}</td>
                  <td>{profile.jobId}</td>
                  <td>{profile.surName}</td>
                  <td>{profile.name}</td>
                  <td>{profile.email}</td>
                  <td>{profile.mobileNumber}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6">No data available</td>
              </tr>
            )}
          </tbody>

        </table>
      </div>
    </React.Fragment>
  );
};

export default Profileinfo;
